import React, {useCallback, useRef} from "react";
import {GridValueFormatterParams} from "@mui/x-data-grid";
import {EmailLogResponse} from "../../../Api/data/emailLog/types";
import CrudList, {SelectMode} from "../../../Crudder/components/CrudList/CrudList";
import {dateTimeFormatter} from "../../../Crudder/utils/utils";

interface IEmailLogListProps {
    /** Loads emails sent regarding the document. Called once on mount - remount (change `key`) to reload. */
    fetchEmails: () => Promise<EmailLogResponse[]>;
}

const listFormatter = (params: GridValueFormatterParams<string[]>) => (params.value ?? []).join(", ");

/** Read-only history of emails sent regarding an invoice or an offer. */
const EmailLogList: React.FC<IEmailLogListProps> = ({fetchEmails}) => {

    // CrudList refetches whenever `data` changes - keep it stable so parent re-renders (form typing) don't trigger requests
    const fetchEmailsRef = useRef(fetchEmails);
    fetchEmailsRef.current = fetchEmails;
    const fetchData = useCallback(() => fetchEmailsRef.current(), []);

    return (
        <CrudList<EmailLogResponse>
            config={{
                title: "Odeslané e-maily",
                getRowID: (email) => email.emailLogID,
                disableAdd: true,
                disableEdit: true,
                disableRemove: true,
                actionsHidden: true,
                hideHeader: true,
                density: "compact",
                selectMode: SelectMode.NONE,
            }}
            itemFields={[
                {
                    name: "sentDate",
                    title: "Odesláno",
                    columnDef: {
                        flex: 2,
                        valueFormatter: dateTimeFormatter
                    },
                },
                {
                    name: "recipients",
                    title: "Komu",
                    columnDef: {
                        flex: 3,
                        valueFormatter: listFormatter
                    },
                },
                {
                    name: "recipientsCC",
                    title: "Kopie",
                    columnDef: {
                        flex: 3,
                        valueFormatter: listFormatter
                    },
                },
                {
                    name: "recipientsBCC",
                    title: "Skrytá kopie",
                    columnDef: {
                        flex: 3,
                        valueFormatter: listFormatter
                    },
                },
                {
                    name: "attachments",
                    title: "Přílohy",
                    columnDef: {
                        flex: 3,
                        valueFormatter: listFormatter
                    },
                },
                {
                    name: "sentBy",
                    title: "Odeslal",
                    columnDef: {
                        flex: 2,
                    },
                },
            ]}
            data={fetchData}
        />
    );
};

export default EmailLogList;
